import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


/** A pipe to print the text without stripping any html */
@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe {
  constructor(private sanitizer: DomSanitizer){}
    
  transform(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}